<template>
  <div>
    <div
      class="text-center d-flex flex-row justify-content-center align-items-center"
    >
      <div id="TopPaginator-info" class="text-no-wrap mr-2">{{ infoText }}</div>
      <i
        :class="page > 0 ? 'hover-pointer text-secondary' : ''"
        class="fas fa-chevron-left p-1 ml-1"
        @click="changePage(page - 1)"
        style="font-size: 15px;"
      ></i
      ><i
        id="TopPaginator-chevron-right"
        :class="page < totalPages ? 'hover-pointer text-secondary' : ''"
        class="fas fa-chevron-right p-1 ml-1"
        @click="changePage(page + 1)"
        style="font-size: 15px;"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopPaginator",
  props: ["total", "page", "perPage"],
  methods: {
    changePage(page) {
      if (page >= 0 && page <= this.totalPages) this.$emit("change-page", page);
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage) - 1;
    },
    infoText() {
      const page = parseInt(this.page);
      const perPage = parseInt(this.perPage);
      const total = parseInt(this.total);
      return `${page * perPage + 1} to ${Math.min(
        (page + 1) * perPage,
        total
      )} of ${total}`;
    }
  }
};
</script>

<style scoped>
.page {
  text-align: center;
  border-radius: 5px;
  border: 1px solid #d8d8d8;
  color: #d8d8d8;
  min-width: 25px;
  height: 25px;
  margin: 0px 3px;
  padding: 0px 3px;
}
.page:hover {
  cursor: pointer;
  background-color: #0091c0;
  border-color: white;
  color: white;
}
.info {
  font-size: 0.8rem;
  color: #0091c0;
  font-weight: bold;
}
.text-no-wrap {
  white-space: nowrap;
}
</style>
